/* @flow */
import { ActionTypes } from 'constants/SetupConstants';
import { dispatcher } from 'lib/Dispatcher';

const SetupActions = {
  joinGroupDuringSetup() {
    dispatcher.dispatch({
      type: ActionTypes.JOIN_CLASS_FOR_SETUP_SESSION,
    });
  },

  removeFlagsForSetupSession() {
    dispatcher.dispatch({
      type: ActionTypes.REMOVE_FLAGS_FOR_SETUP_SESSION,
    });
  },
};

export default SetupActions;



// WEBPACK FOOTER //
// ./src/actions/SetupActions.js